export default class QuotationRequestWithValues {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.id = jsonResponse["id"];
            this.countryId = jsonResponse["country-id"];
            this.countryCode = jsonResponse["country-code"];
            this.countryName = jsonResponse["country-name"];

            this.payoutMethodId = jsonResponse["payout-method-id"];
            this.payoutMethod = jsonResponse["payout-method"];

            this.payoutPartnerId = jsonResponse["payout-partner-id"];
            this.payoutPartnerName = jsonResponse["payout-partner-name"];

            this.currencyId = jsonResponse["currency-id"];
            this.currencyCode = jsonResponse["currency-code"];
            this.quotationType = jsonResponse["quotation-type"];
            this.quotationTypeDisplay = jsonResponse["quotation-type-display"];
            this.amount = jsonResponse["amount"];
        }
    }
}